/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "88")
  

// 接口文档

  
    
export interface IAPI65658ResUserListItem {
  
  /** 用户id */
  userId?: string;
  
  /** 花名 */
  userName?: string;
  
  /** 真实姓名 */
  realName?: string;
  
  /** 头像 */
  headIconUrl?: string;
  
  /** 职位 */
  position?: string;
  
  /** 主部门id */
  orgId?: string;
  
  /** 主部门全路径 */
  orgPathDesc?: string;
  
  /** 手机号 */
  userPhone?: string;
  
};
    
  



export interface API65658Req {
  
  /** 根据该部门id查询部门树和用户数据聚合树(String) */
  orgId?: string;
    
};



export interface API65658Res {
  /** 部门下的总用户数  */
  userTotal?: number;
  /** 用户数据集合 ,BaseUserDTO  */
  userList?: IAPI65658ResUserListItem[];
  /** 部门id  */
  orgId?: string;
  /** 部门名称  */
  orgName?: string;
  /** 父级部门id  */
  orgParentId?: string;
  /** 子部门数据 ,SelectorOrgUserDTO  */
  subOrgList?: any[];
  
};


// 接口函数 65658 获取部门用户聚合树

export interface IUseGetAPI65658Return {
  /** 获取部门用户聚合树: 接口请求状态 */
  isAPI65658Loading: boolean;
  /** 获取部门用户聚合树: 接口请求返回数据 */
  dataAPI65658: API65658Res;
  /**  获取部门用户聚合树: 接口数据请求方法 */
  fetchAPI65658Data: (inputs: API65658Req, config?: YWRequestConfig) => Promise<API65658Res>;
  /** 获取部门用户聚合树: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI65658 = ():IUseGetAPI65658Return => {
  let isMount = true;
  const [isAPI65658Loading, setIsAPI65658Loading] = useState(false);
  const [dataAPI65658, setDataAPI65658] = useState<API65658Res>({} as API65658Res);
  const requestUrl = `${basePath}/ywwl-admin/selector/listOrgAndUserTree`;

  const fetchAPI65658Data = async (inputs: API65658Req, config?: YWRequestConfig): Promise<API65658Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API65658Req>) || {}) as API65658Req;
    
  
    if ( isMount ) {
      setIsAPI65658Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API65658Res>(`${basePath}/ywwl-admin/selector/listOrgAndUserTree?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI65658(res || {} as API65658Res);
        setIsAPI65658Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI65658Loading(false);
      }
      return false as unknown as API65658Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI65658Loading,
    dataAPI65658,
    fetchAPI65658Data,
    requestUrl,
  }
}

